<template>
    <div :id="editorId"></div>
</template>

<script>
  export default ({
    name:'Editor',
    props: ['editorId', 'content', 'lang', 'theme'],
    data () {
      return { editor: Object }
    },
    watch: {
      'content' (value) { this.editor.setValue(value) }
    },
    mounted () {
      this.editor = ace.edit(this.editorId)
      this.editor.setOptions({
        value: this.content,
        mode: "ace/mode/"+(this.lang || "text"),
        theme: "ace/theme/"+(this.theme || "github"),
        readOnly: true,
        maxLines: 24,
        autoScrollEditorIntoView: true, // Scroll the window when the code dragging selection reach the bottom of the window
        //useWorker: false, // Disable syntax checker
      });
      this.editor.on('change', () => { this.$emit('change-content', this.editor.getValue()) })
    }
  })
</script>

<style scoped>
  div{
    border: 1px solid #ddd;
    font-size: 18px;
  }
  @media (width < 1000px) {
    div{
      font-size: 12px;
    }
  }
</style>
